// Leaf module for token storage keys — safe to import from anywhere
// (notably ModalService) without dragging in AuthenticationService,
// whose module graph reaches app.component and causes circular-init
// issues.
export const ACCESS_TOKEN = 'access_token';
export const REFRESH_TOKEN = 'refresh_token';

/**
 * Reads as signed out off-browser, the same answer
 * `AuthenticationService.getTokens()` gives there.
 *
 * A `typeof` test rather than `isPlatformBrowser`, because this module is
 * deliberately dependency-free (see above) and injecting PLATFORM_ID would
 * give it the module graph it exists to avoid. Same shape as the `typeof
 * location` guard in `captureTrafficSource`.
 *
 * Needed because this is the *second* token reader, independent of
 * `getTokens()`: five call sites import it - ModalService, reports.service,
 * comparative-location.service and oauth.ts - and a server render reaches it
 * through ReportsComponent, so prerendering /reports/order threw here.
 * Guarding the one function covers all five.
 */
export function hasStoredAccessToken(): boolean {
  if (typeof localStorage === 'undefined') return false;

  const token = localStorage.getItem(ACCESS_TOKEN);
  return token !== null && token !== '';
}
